<template>
  <tr @click="goToExpedition(expedition.id)">
    <td>{{ expeditionName }}</td>
    <td>
      <v-progress-circular
        style="vertical-align: text-bottom;"
        class="mr-2"
        size="18"
        :color="loadingProgressColor"
        :value="loadingRatio"
      ></v-progress-circular>

      {{ (Math.round(1000 * totalLoadedNetWeight) / 1000).toFixed(3) }}/{{
        (
          Math.round((1000 * Math.round(1000 * maxLoadedNetWeight)) / 1000) /
          1000
        ).toFixed(3)
      }}mt
    </td>
    <td>
      <v-progress-circular
        style="vertical-align: text-bottom;"
        class="mr-2"
        size="18"
        :color="cardColor(stepsCompleted(expedition), expedition.steps.length)"
        :value="stepsCompletedPercentage(expedition)"
      ></v-progress-circular>
      {{ stepsCompleted(expedition) }}/{{ expedition.steps.length }}
    </td>

    <td>
      <div v-if="!allStepValidated">
        <v-tooltip bottom>
          <span>
            Go to
            <strong>{{ nextStepToValidate }}</strong>
          </span>
          <a
            @click.stop="goToExpedition(expedition.id, 'steps')"
            slot="activator"
          >
            <span style="text-decoration: underline;">{{
              truncate(nextStepToValidate)
            }}</span>
          </a>
        </v-tooltip>
      </div>
      <div v-else>All steps Completed</div>
    </td>
    <td>
      <v-icon v-if="!expedition.bl_number" small color="error">warning</v-icon>

      <a
        v-if="
          expedition.bl_number &&
          expedition.shipping_company &&
          expedition.shipping_company.supplier.shipping_tracking_url_bl
        "
        @click.stop
        :href="
          expedition.shipping_company.supplier.shipping_tracking_url_bl
            .toString()
            .replace('{{reference}}', expedition.bl_number)
        "
        target="_blank"
        >{{ expedition.bl_number }}</a
      >
      <span v-else>{{
        expedition.bl_number ? expedition.bl_number : "Missing"
      }}</span>
    </td>
    <!-- <td>No tracking yet</td> -->

    <td>{{ expedition.etd ? timeToDate(expedition.etd) : "Unknown" }}</td>

    <td>
      <v-tooltip
        bottom
        right
        color="error"
        v-show="!completed && lessThan7DaysAway(expedition.eta)"
      >
        <span class="font-weight-bold">ETA is less than a week away!</span>

        <v-icon slot="activator" small color="amber darken-1">warning</v-icon>
      </v-tooltip>
      {{ expedition.eta ? timeToDate(expedition.eta) : "Unknown" }}
    </td>
  </tr>
</template>

<script>
import date from "../../mixins/date.js";
export default {
  mixins: [date],
  components: {},
  props: {
    expedition: {
      type: Object,
      required: true,
    },
    expeditionName: {
      type: String,
      required: true,
    },
    completed: {
      type: Boolean,
      required: true,
    },
    redirect: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    notValidatedSteps() {
      return this.expedition.steps.filter((s) => !s.validated);
    },
    allStepValidated() {
      return this.notValidatedSteps.length === 0;
    },
    nextStepToValidate() {
      if (this.allStepValidated) return "";

      let upload_steps = this.notValidatedSteps.sort((a, b) => {
        if (
          !a.step_template ||
          !b.step_template ||
          !a.step_template.step_template_group ||
          !b.step_template.step_template_group
        )
          return -1;
        if (
          a.step_template.step_template_group.order_index ==
          b.step_template.step_template_group.order_index
        )
          return a.step_template.order_index < b.step_template.order_index
            ? -1
            : 1;
        else
          return a.step_template.step_template_group.order_index <
            b.step_template.step_template_group.order_index
            ? -1
            : 1;
      });
      return upload_steps[0].step_template.name;
    },
    totalLoadedNetWeight() {
      let total = 0;
      if (!this.expedition.shipping_units) return 0;
      this.expedition.shipping_units.forEach((shipping_unit) => {
        shipping_unit.shipping_unit_products.forEach((sup) => {
          total += sup.loaded_net_weight_mt;
        });
      });
      return total;
    },
    maxLoadedNetWeight() {
      return this.expedition.net_weight * this.expedition.shipping_units.length;
    },
    loadingRatio() {
      return (this.totalLoadedNetWeight / this.maxLoadedNetWeight) * 100;
    },
    loadingProgressColor() {
      if (this.loadingRatio <= 0) return "error";
      else if (this.loadingRatio < 100) return "amber darken-1";
      return "green";
    },
  },
  methods: {
    truncate(input) {
      if (input.length > 32) return input.substring(0, 32) + "...";
      else return input;
    },
    goToExpedition(expeditionID, tab) {
      let query = { id: expeditionID, tab: tab };
      if (tab === "steps") query.open_step = true;

      if (this.redirect) {
        this.$router.push({
          name: "expeditions",
          params: { id: this.expedition.contract.id },
          query: query,
        });
      }
      else {
        this.$router.push({
          name: "expeditions",
          query: query,
        });
      }
    },
    stepsCompleted(expedition) {
      let completed_steps = 0;

      expedition.steps.forEach((s) => {
        completed_steps += s.validated;
      });
      return completed_steps;
    },
    stepsCompletedPercentage(expedition) {
      let temp_stepsCompleted = this.stepsCompleted(expedition);
      return temp_stepsCompleted
        ? Math.round((temp_stepsCompleted / expedition.steps.length) * 100)
        : 0;
    },
    etaColor(eta) {
      let color = "error";

      if (eta) color = "blue";

      return color;
    },
    lessThan7DaysAway(date) {
      //Get the date value of next week.
      var today = new Date();
      var nextWeek = Date.parse(
        new Date(today.getFullYear(), today.getMonth(), today.getDate() + 7)
      );

      //If nextWeek is smaller (earlier) than the value of the input date, alert...
      if (date == "" || date == null || nextWeek < Date.parse(date)) {
        return false;
      } else {
        return true;
      }
    },
    cardColor(value, max) {
      if (value == 0 || value > max) {
        return "error";
      }

      if (value == max) {
        return "ctcGreen";
      }

      return "amber darken-1";
    },
  },
};
</script>
